export class ManagerProperties {
  managerId: number = 0;
  userId: number = 0;
  managerName: string = "";
  managerEmailAddress: string = "";
  managerPhone: string = "";
  creationUser: number = 0;
  creationDate: string = ""

}
